import gql from 'graphql-tag';

export const TRAVEL_FRAGMENT = gql`
  fragment TravelFragment on EventInfo {
    travel {
      __typename
      ... on EventTravelBookingType {
        id
        name
        address
        bookingType
        startDate
        endDate
        timezone
        latitude
        longitude
        placeId
      }
      ... on Flight {
        id
        name
        url
        code
        notes
      }
      ... on RentalCar {
        id
        name
        address
        telephone
        notes
        url
      }
      ... on Taxi {
        id
        name
        address
        telephone
        notes
        url
      }
      ... on EventTravelNote {
        id
        name
        notes
      }
      ... on Train {
        id
        name
        address
        telephone
        notes
        url
      }
      ... on Ferry {
        id
        name
        address
        telephone
        url
        notes
      }
      ... on Shuttle {
        id
        name
        notes
        items {
          id
          note
          dateStart
          dateEnd
        }
      }
      ... on EventTravelList {
        id
        name
        items {
          id
          title
          url
        }
      }
      ... on Hotel {
        id
        name
        address
        telephone
        url
        notes
      }
      ... on Tent {
        id
        name
        address
        telephone
        url
        notes
      }
      ... on RentalHome {
        id
        name
        address
        notes
      }
      ... on EventTravelBookingType {
        id
        name
        address
        bookingType
        startDate
        endDate
        timezone
        latitude
        longitude
        placeId
      }
		}
  }
`;
